import React, { useState, useRef } from 'react';
import AuthHeader from '../../components/Navbar/AuthHeader';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { resendEmailOtp, verifyEmailOtp } from '../../actions/auth';
import { useDispatch } from 'react-redux';

function Otp() {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const sessionId = localStorage.getItem('sessionId');
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const userDetails = localStorage.getItem('userDetails');
    const userEmail = location.state?.email;

    const [countdown, setCountdown] = useState(60); // 1 min
    // const userAgent = navigator.userAgent;
    // console.log(userAgent);

    const formatCountdown = (seconds) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${secs}`;
    };

    React.useEffect(() => {
        if (countdown <= 0) return;

        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown]);



    const handleInput = (e, index) => {
        const value = e.target.value;

        if (!/^\d*$/.test(value)) return; // only allow digits

        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }

        setHasError(false); // Allow resubmission
        setHasSubmitted(false);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text').trim();
        if (!/^\d{6}$/.test(paste)) return;

        const newOtp = paste.split('');
        setOtp(newOtp);

        inputRefs.current[5]?.focus(); // Move focus to last input

        setHasError(false);
        setHasSubmitted(false);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];
            if (otp[index] === "") {
                if (index > 0) {
                    newOtp[index - 1] = "";
                    setOtp(newOtp);
                    inputRefs.current[index - 1]?.focus();
                }
            } else {
                newOtp[index] = "";
                setOtp(newOtp);
            }
            setHasSubmitted(false);
        }
    };

    React.useEffect(() => {
        const otpValue = otp.join('');
        if (otpValue.length === 6 && !hasSubmitted && !hasError) {
            const email = userDetails ? JSON.parse(userDetails).email : userEmail;
            const credentials = {
                email,
                two_factor_code: otpValue
            };
            verifyEmailOtp(email, otpValue, navigate, dispatch, setIsLoading, setSuccessMessage, setErrorMessage)
                .then(() => setHasSubmitted(true))
                .catch(() => {
                    setHasError(true);
                    setHasSubmitted(false);
                });
        }
    }, [otp]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!sessionId) {
        //     console.error("Session ID not found!");
        //     setTimeout(() => navigate('/getstarted'), 0);
        //     return;
        // }

        const otpValue = otp.join("");
        if (otpValue.length !== 6) {
            setErrorMessage("Invalid OTP value");
            setTimeout(() => setErrorMessage(""), 5000);
            return;
        }
        const email = userDetails ? JSON.parse(userDetails).email : userEmail;

        await verifyEmailOtp(email, otpValue, navigate, dispatch, setIsLoading, setSuccessMessage, setErrorMessage);
    }

    const handleResendOtp = async () => {
        const email = userDetails ? JSON.parse(userDetails).email : userEmail;
        await resendEmailOtp(email, navigate, setIsLoading, setSuccessMessage, setErrorMessage);
        setCountdown(60);
    };



    return (
        <div style={{ background: '#13053A', minHeight: '100vh' }}>
            <AuthHeader />
            <div className="auth__container padding__tb__30">
                <div className='auth__container__box'>
                    <h3>OTP Verification</h3>
                    <p className='auth__text'>
                        Check your Email for a One-Time Password (OTP) to verify your identity
                    </p>
                    <ProgressSteps currentStep={4} totalSteps={4} />

                    {successMessage && (
                        <div className="text-center text-success success-container">{successMessage}</div>
                    )}
                    {errorMessage && (
                        <div className="text-center text-danger error-container">{errorMessage}</div>
                    )}

                    <div className='auth__container__form w-full'>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <div className='form__group mb-4'>
                                        <label htmlFor='otp' className='label__form'>
                                            One-Time Password
                                        </label>
                                        <div className="otp-input-container">
                                            {otp.map((digit, index) => (
                                                <input
                                                    key={index}
                                                    type="text"
                                                    maxLength={1}
                                                    value={digit}
                                                    className='auth__form__input verify-code'
                                                    onChange={(e) => handleInput(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handlePaste}
                                                    ref={(el) => inputRefs.current[index] = el}
                                                    inputMode="numeric"
                                                    autoComplete="one-time-code"
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className='form__group mb-3'>
                                    <button
                                        type='submit'
                                        className='btn btn__block'

                                    >
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : 'Continue'}
                                    </button>
                                </div>
                                <div className='mb-4'>
                                    {countdown > 0 ? (
                                        <div className="text-center small text-muted">
                                            <p>
                                                Resend code in <span className="text-danger">{formatCountdown(countdown)}</span>
                                            </p>
                                        </div>
                                    ) : (
                                        <p className='text-center'>
                                            Didn't get OTP?{' '}
                                            <Link onClick={handleResendOtp} className='text-decoration-underline'>
                                                Click here
                                            </Link>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Otp;